import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../axiosInstance';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DataTableComponent from '../../common/DataTable/PrimeDataTable';
import ActivateDeactivateModal from '../../common/ActivateDeactivateModal';
import { convertUTCToLocal } from '../../utils/dateUtils';

const UserList = ({ persona }) => {
  const [t] = useTranslation();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [confirmActivateModal, setConfirmActivateModal] = useState({
    open: false,
    record: null,
  });
  const [paginationParams, setPaginationParams] = useState({
    limit: 10,
    offset: 0,
    sortField: 'createdAt',
    sortOrder: -1,
  });
  const navigate = useNavigate();

  useEffect(() => {
    fetchUsers();
  }, [paginationParams]);

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance
        .get(
          // eslint-disable-next-line no-undef
          `${process.env.REACT_APP_SERVER_URL}/api/users`,
          { withCredentials: true },
          {
            limit: paginationParams.limit,
            offset: paginationParams.offset,
          }
        )
        .catch((err) => {
          console.log(err);
        });

      setData(response?.data || []);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const onDataTableEvent = (event) => {
    setPaginationParams((prev) => ({
      ...prev,
      limit: event.rows,
      offset: event.first,
      sortField: event.sortField || prev.sortField,
      sortOrder: event.sortOrder || prev.sortOrder,
    }));
  };

  const columns = [
    { field: 'id', header: t('id'), sortable: true },
    {
      field: 'username',
      header: t('Username'),
      sortable: true,
      filter: true,
    },
    { field: 'email', header: t('email'), sortable: true, filter: true },
    { field: 'Role.name', header: t('role'), sortable: true, filter: true },
    {
      field: 'createdAt',
      header: t('Created At'),
      sortable: true,
      filter: true,
      body: (rowData) => convertUTCToLocal(rowData.createdAt),
    },
  ];

  const actions = [
    {
      text: t('manage'),
      color: 'secondary',
      onClick: (row) => {
        navigate(`/${persona}/users/${row.id}/profile`);
      },
    },
    {
      text: t('Activate / Deactivate'),
      onClick: (row) => setConfirmActivateModal({ open: true, record: row }),
      color: 'primary',
      status: 'success',
    },
  ];

  return (
    <div>
      <DataTableComponent
        data={data}
        columns={columns}
        loading={loading}
        paginationParams={paginationParams}
        totalRecords={data?.length}
        onDataTableEvent={onDataTableEvent}
        enableCreate={true}
        enablePagination={true}
        enableLazyLoading={false}
        enableExport={true}
        actions={actions}
        sectionName={`Users-${new Date().getDate()}-${new Date().getMonth() + 1}-${new Date().getFullYear()}-${new Date().getHours()}-${new Date().getMinutes()}`}
      />

      {confirmActivateModal.open && (
        <ActivateDeactivateModal
          sentData={confirmActivateModal.record}
          onEvent={setConfirmActivateModal}
          onConfirm={fetchUsers}
          apiPath="users"
          axios={axiosInstance}
          columnName="username"
          dbAction="active"
        />
      )}
    </div>
  );
};

export default UserList;
